/**
 * Bloque de WhatsApp de la portada (WSP-01).
 *
 * Dice explicitamente que responde una persona: es la ventaja real frente a la
 * competencia grande y es lo que hace que el cliente escriba en vez de irse.
 */
import { SITIO } from '../../configuracion/sitio';
import { registrarClicWhatsapp } from '../../servicios/metricas.servicio';
import { whatsappGeneral } from '../../utilidades/whatsapp';
import { Icono } from '../comunes/Icono';

const PROMESAS = [
  'Confirmamos stock al instante',
  'Asesoría técnica de taller',
  'Cotizamos tu pedido completo',
  SITIO.horario,
];

export function PanelWhatsapp() {
  return (
    <section className="panel-wa" aria-labelledby="titulo-whatsapp">
      <div>
        <h2 id="titulo-whatsapp">¿Alguna duda? Escríbenos por WhatsApp</h2>
        <p>
          Te responde un vendedor de verdad, no un robot. Te confirmamos stock, te decimos que
          herraje o material te sirve para lo que estás haciendo y armamos el pedido contigo.
        </p>
        <ul className="lista">
          {PROMESAS.map((promesa) => (
            <li key={promesa}>
              <Icono nombre="checkCirc" />
              {promesa}
            </li>
          ))}
        </ul>
      </div>
      <a
        className="btn btn-lg btn-wa"
        href={whatsappGeneral()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => registrarClicWhatsapp({ origen: 'portada' })}
      >
        <Icono nombre="wa" />
        Escribir ahora
      </a>
    </section>
  );
}
